import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let current = 0;
const listeners = new Set<() => void>();

function publish(next: number) {
  current = next;
  listeners.forEach((fn) => fn());
}

/** Reload the Messages nav count. Safe to call after a conversation is opened. */
export function refreshUnreadNavCount() {
  return api<{ success: boolean; data?: { total?: number } }>("/api/schools/unread-count")
    .then((envelope) => {
      publish(Number(envelope.data?.total) || 0);
    })
    .catch(() => {
      publish(0);
    });
}

/** Unread office and direct messages. Stays at zero when Messages is not in the nav. */
export function useUnreadNavCount(enabled: boolean, refreshKey = "") {
  const [value, setValue] = useState(current);
  useEffect(() => {
    if (!enabled) {
      setValue(0);
      return;
    }
    const follow = () => setValue(current);
    listeners.add(follow);
    void refreshUnreadNavCount();
    return () => {
      listeners.delete(follow);
    };
  }, [enabled, refreshKey]);
  return enabled ? value : 0;
}
